import { useState, useCallback, useRef, useEffect, } from 'react';
import { connect } from 'react-redux';

import { PROMO_CODE_SET_NOTE, SET_NOTE_PROMO_CODE_DIALOGUE_OPEN, ShareScheduleCode, } from '../actions/types';
import { siteboardAction, } from '../actions/defaultActions';
import PopupWindow from './PopupWindow';
import PushButton from './PushButton';

const SetNotePromoCodeDialogue = ({ _promoCodes, _setNotePromoCodeDialoguePromoCodeId, siteboardAction, _isTouchDevice, }) => {
  const selectedPromoCode = _promoCodes[_setNotePromoCodeDialoguePromoCodeId];

  const inputRef = useRef(null);
  const [inputNote, setInputNote] = useState(selectedPromoCode ? selectedPromoCode.note : '');

  useEffect(() => {
    // Don't auto focus for touch devices because it changes the screen layout too much when the virtual keyboard appears
    if(_isTouchDevice === true) return;
    
    if(inputRef.current) {
      inputRef.current.focus();
    }
  }, [_isTouchDevice]);

  const closeDialogue = useCallback(() => {
    siteboardAction(SET_NOTE_PROMO_CODE_DIALOGUE_OPEN, { isOpen: false, promoCodeId: '', });
  }, [siteboardAction]);

  const onUpdatePromoNote = () => {
    const onSuccess = () => {
      closeDialogue();
    };
    siteboardAction(PROMO_CODE_SET_NOTE, { code: selectedPromoCode.code, note: inputNote }, onSuccess);
  };

  if(selectedPromoCode === undefined) return (<></>);

  return (
    <PopupWindow title='Set Note' closeDialogue={closeDialogue} bgStyle='bg-[#333]'>
      <div className='max-w-[400px] bg-[#333] text-white'>
        <div className='w-[400px]' />
        <div className='py-2'>
          Set a note for promo code <b>{ShareScheduleCode.truncate(selectedPromoCode.code)}</b>. 
        </div>
        <div className='mt-1'>
          <input 
            ref={inputRef}
            className='w-full text-white rounded-md px-3 py-1.5 bg-[#444247] hover:bg-[#656565] focus:bg-[#656565]' 
            type='text' 
            value={inputNote}
            onChange={(event) => { 
              setInputNote(event.target.value); 
            }}
            onKeyDown={(event) => { 
              if(event.key === 'Enter') { onUpdatePromoNote() };
            }}
          />
        </div>
        <div className='flex mt-4'>
          <PushButton 
            textColor='white'
            bgColor='#471cff'
            hoverBgColor='#603aff'
            onClick={onUpdatePromoNote}
          >
            Set Note
          </PushButton>
        </div>
      </div>
    </PopupWindow>
  );
};

// define redux state that will be passed in as props
const mapStateToProps = state => { return {
  _promoCodes: state.serverSynced.promoCodes,
  _setNotePromoCodeDialoguePromoCodeId: state.localEphemeral.setNotePromoCodeDialoguePromoCodeId,
  _isTouchDevice: state.localEphemeral.isTouchDevice,
}};
export default connect(mapStateToProps, { siteboardAction })(SetNotePromoCodeDialogue);
